import { format } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FaPercent } from 'react-icons/fa';
import { Col, Modal, ModalBody, ModalFooter, Row } from 'reactstrap';
import { Button } from 'ui-kit-takeat';
import { useAuth } from '~/context/AuthContext';
import { useCart } from '~/context/OrderingSystem/Cart';
import apiClube from '~/services/apiClube';
import formatValue from '~/utils/formatValue';
import { Input, Button as NewButton } from 'takeat-design-system-ui-kit';
import { useTheme } from 'styled-components';
import { BANESTES_METHOD, CLUBE_METHOD } from '~/utils/consts';
import api2 from '~/services/api2';
import {
  ClientArea,
  ClubArea,
  Container,
  DiscountApplied,
  Value,
  ValuesArea,
} from '../Payments/styles';

import { AddClients } from '../Cart/Clients/index';
import BalconyButton from '../../balcony-button';
import { ReactComponent as Image } from '../../../../assets/img/money.svg';

const BalconyOrderTemplate = ({
  makeOrder,
  clubInfo,
  setClubInfo,
  setBuyerName,
  buyerName,
  clientCashback,
  setClientCashback,
  banestesPayment,
  setBanestesPayment,
  setMetodoAndPaymentOption,
  discount,
  discountPercent,
  setModalDiscount,
  loadingPos,
  toggleCancelPos,
  modalCancelPos,
  handleCancelStoneTransactions,
  handleUpdateCashbackValue,
  cashbackValue,
  handleUpdateUseCashback,
  usingCashback,
}) => {
  const theme = useTheme();
  const { user, setData } = useAuth();
  const { cart } = useCart();
  const [clientRegister, setClientRegister] = useState(true);
  const [addClientModal, setAddClientModal] = useState(false);
  const [loadingCashback, setLoadingCashback] = useState(false);
  const [hasClient, setHasClient] = useState(false);
  const [loading, setLoading] = useState(false);

  const getCashback = useCallback(async () => {
    try {
      let login_club;
      setLoadingCashback(true);

      if (!user.club_login) {
        login_club = await apiClube.post('/public/sessions/takeat', {
          token: user.token_clube,
        });

        localStorage.setItem(
          '@gddashboard:user',
          JSON.stringify({
            ...user,
            club_login: login_club.data.token,
            minimo: login_club.data.user?.settings[0]?.minimo,
          })
        );

        setData((state) => {
          return {
            ...state,
            user: {
              ...user,
              club_login: login_club.data.token,
              minimo: login_club.data.user?.settings[0]?.minimo,
            },
          };
        });
      }

      const response = await apiClube.get(`/store/cashback/${clubInfo.phone}`, {
        headers: {
          Authorization: `Bearer: ${user.club_login || login_club.data.token}`,
        },
      });

      setClientCashback(response.data);
    } catch (err) {
      setClientCashback({ date: null, value: 0 });
      if (err.response?.data?.errorType === 'default_error') {
        toast.error(
          <span>
            Telefone não cadastrado no <b>Clube!</b>
          </span>
        );
      } else {
        toast.error(
          'Não foi possível buscar o cashback referente a este telefone'
        );
      }
    } finally {
      setClientRegister(false);
    }
    setLoadingCashback(false);
  }, [user.club_login, clubInfo.phone]);

  useEffect(() => {
    if (user.has_clube && clubInfo.phone?.length === 15) {
      getCashback();
    }

    if (clubInfo.phone?.length < 15) {
      setClientRegister(true);
      setClientCashback({ date: null, value: 0 });
    }
  }, [clubInfo.phone]);

  useEffect(() => {
    if (
      clubInfo.date.length === 10 &&
      clientCashback.date &&
      format(new Date(clientCashback.date.slice(0, -1)), 'dd/MM/yyyy') !==
        clubInfo.date
    ) {
      toast.error('Data informada não coincide com a cadastrada');
    }
  }, [clubInfo.date]);

  const getClientStatus = () => {
    if (!hasClient) {
      return clientCashback?.date
        ? 'Cliente cadastrado apenas no clube'
        : 'Cliente novo';
    }

    return clientCashback?.date ? '' : 'Cliente sem cadastro no clube';
  };

  const rescueBanestes = async () => {
    setBanestesPayment((state) => ({ ...state, loading: true }));
    try {
      const { data } = await api2.get(
        `/restaurants/banestes/validate-code/${banestesPayment.code}`
      );

      if (!data.exists) {
        toast.error(
          data.message || 'Algo deu errado. Tente novamente em breve.'
        );
        setBanestesPayment((state) => ({ ...state, loading: false }));
        return;
      }

      setMetodoAndPaymentOption({
        label: 'Resgate Banestes',
        id: BANESTES_METHOD,
        value: data.value,
        keyword: 'pontos_banestes',
        code: banestesPayment.code,
      });
      setBanestesPayment({ code: '', loading: false });
      toast.success('Resgate Banestes efetuado com sucesso!');
    } catch (err) {
      console.log('rescueBanestes error: ', err);
      toast.error(
        err?.response?.data?.message ||
          'Algo deu errado. Tente novamente em breve.'
      );
    }
    setBanestesPayment((state) => ({ ...state, loading: false }));
  };

  const total = cart?.reduce((acc, item) => {
    const price = parseFloat(item.price) * item.amount;
    return acc + (isNaN(price) ? 0 : price);
  }, 0);

  return (
    <div>
      <Container>
        <h3>Pagamento</h3>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <BalconyButton
            variant="discount"
            icon={<FaPercent width={14} height={14} />}
            onClick={() => {
              if (cart.length <= 0) {
                toast.error(
                  'Adicione produtos ao carrinho para aplicar desconto'
                );
                return;
              }

              setModalDiscount(true);
            }}
          >
            Aplicar desconto
          </BalconyButton>
          {discount && (
            <DiscountApplied>
              <p>Desconto aplicado:</p>
              <p style={{ fontWeight: 500 }}>
                {formatValue(discount)} ({discountPercent}%)
              </p>
            </DiscountApplied>
          )}
        </div>

        <ClientArea>
          <Input
            label="Celular"
            mask="(99) 99999-9999"
            isLoading={loadingCashback}
            disabled={loadingCashback}
            value={clubInfo.phone}
            onChange={(e) => {
              const newPhone = e.target.value;
              if (buyerName?.length > 0) {
                setBuyerName('');
              }
              if (e.target.value === '(') {
                setClientRegister(true);
              }

              setClubInfo((state) => {
                return { ...state, phone: newPhone };
              });
            }}
          />

          <Input
            label="Nome"
            isLoading={loadingCashback}
            disabled={loadingCashback}
            value={buyerName || ''}
            onChange={(e) => {
              setBuyerName(e.target.value);
            }}
          />
          {!clientRegister && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 8,
              }}
            >
              <p style={{ color: '#FF2C3A', margin: 0 }}>{getClientStatus()}</p>

              <p
                style={{
                  margin: 0,
                  color: '#2EC9B7',
                  cursor: 'pointer',
                  fontWeight: 600,
                  textAlign: 'right',
                }}
                onClick={() => setAddClientModal(true)}
              >
                {hasClient
                  ? 'Editar informações'
                  : clientCashback?.date
                  ? 'Cadastrar na Takeat'
                  : 'Adicionar mais informações'}
              </p>
            </div>
          )}
          {clubInfo?.phone?.length === 15 && (
            <AddClients
              addClientModal={addClientModal}
              setAddClientModal={setAddClientModal}
              clientPhone={clubInfo.phone}
              setHasClientParent={setHasClient}
              setBuyerName={setBuyerName}
              clientCashback={clientCashback}
            />
          )}

          {user.has_clube && clientCashback.date !== null && (
            <ClubArea>
              <h3>Takeat Clube</h3>
              <div className="buttons-div">
                <Input
                  label="Data de nascimento"
                  mask="99/99/9999"
                  placeholder="dd/mm/aaaa"
                  value={clubInfo.date}
                  onChange={(e) => {
                    const newDate = e.target.value;
                    setClubInfo((state) => {
                      return { ...state, date: newDate };
                    });
                  }}
                />
                <NewButton
                  style={{ width: '50%' }}
                  disabled={
                    format(
                      new Date(clientCashback?.date.slice(0, -1) || null),
                      'dd/MM/yyyy'
                    ) !== clubInfo?.date ||
                    parseFloat(clientCashback?.value) <= 0
                  }
                  variant={usingCashback ? 'default' : 'outlined'}
                  onClick={(e) => {
                    e.preventDefault();
                    if (cart.length <= 0) {
                      toast.error(
                        'Adicione produtos ao carrinho para adicionar pagamento'
                      );
                      return;
                    }

                    handleUpdateCashbackValue(clientCashback.value);
                    handleUpdateUseCashback(!usingCashback);
                  }}
                >
                  Resgatar {formatValue(clientCashback.value)}
                </NewButton>
              </div>
            </ClubArea>
          )}
          {user.use_banestes && (
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
              <Input
                maxLength={6}
                style={{ width: '50%' }}
                label={
                  <span
                    style={{
                      whiteSpace: 'nowrap',
                      color: theme.colors.neutral.dark,
                    }}
                  >
                    Pagar com pontos (Banestes)
                  </span>
                }
                placeholder="XXXXXX"
                value={banestesPayment.code}
                onChange={(e) => {
                  const newCode = e?.target?.value.toUpperCase();
                  setBanestesPayment((state) => ({
                    ...state,
                    code: newCode,
                  }));
                }}
              />
              <NewButton
                disabled={banestesPayment.code.length < 6}
                isLoading={banestesPayment.loading}
                style={{ flexGrow: 1 }}
                customColor={theme.colors.green.default}
                onClick={() => rescueBanestes()}
              >
                Resgatar
              </NewButton>
            </div>
          )}
        </ClientArea>
        <ValuesArea>
          <Value>
            <span>
              <b>Total</b>
            </span>
            <span>
              {formatValue(total)}
              {usingCashback && <b> - {formatValue(cashbackValue)}</b>}
            </span>
          </Value>
          <NewButton
            icon={<Image />}
            disabled={loading}
            isLoading={loading}
            children="Realizar pagamento"
            onClick={async () => {
              setLoading(true);
              try {
                await makeOrder(false);
              } finally {
                setLoading(false);
              }
            }}
            style={{
              fontFamily: 'Poppins',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: '20px',
              letterSpacing: '0.1px',
              padding: '0px 22.08px',
            }}
          />
        </ValuesArea>
        <Modal isOpen={modalCancelPos} toggle={toggleCancelPos}>
          <ModalBody style={{ padding: 20 }}>
            <Row style={{ paddingTop: 15 }}>
              <Col md="12">Deseja cancelar esse pagamento na POS?</Col>
            </Row>
          </ModalBody>
          <ModalFooter style={{ marginLeft: 'auto' }}>
            <Button
              title="Sim, cancelar"
              buttonColor="#2ec9b7"
              disabled={loadingPos}
              onClick={(e) => handleCancelStoneTransactions()}
            />
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default BalconyOrderTemplate;
